import { useQuery, UseQueryResult } from 'react-query'
import { TreatmentUpsellDetails } from '@customTypes/TreatmentUpsellDetails'
import { InsuranceTypeOptions } from 'src/config/insuranceTypeOptions'
import { getTreatmentUpsellDetails } from 'src/services/api/treatment'
import { useChoiceState } from '@context/ChoiceContext'
import { useConfig } from '@context/ConfigurationContext'
import { setUpsell, useUpsellContext, useUpsellDispatch } from '@context/UpsellContext'

const useTreatmentUpsellDetails: () => UseQueryResult<TreatmentUpsellDetails | undefined> = () => {
  const { clinicId } = useConfig()
  const { treatmentBundleTypeReferenceId, insuranceType } = useChoiceState()
  const { canTheoreticallyBeUpsold } = useUpsellContext()
  const upsellDispatch = useUpsellDispatch()
  const insurance = insuranceType || InsuranceTypeOptions.SOCIAL_INSURANCE

  const result = useQuery(
    ['treatmentUpsellDetails', clinicId, treatmentBundleTypeReferenceId, insurance],
    () => getTreatmentUpsellDetails(clinicId, treatmentBundleTypeReferenceId, insurance),
    {
      enabled: !!clinicId && !!treatmentBundleTypeReferenceId && canTheoreticallyBeUpsold,
      onSuccess(data) {
        if (data) upsellDispatch(setUpsell(data))
      },
    }
  )

  return result
}

export default useTreatmentUpsellDetails
